import * as constants from "../constants";

export interface ShowPowerUserTools {
    type: constants.SHOW_POWER_USER_TOOLS;
}

export function showPowerUserTools(): ShowPowerUserTools {
    return {
        type: constants.SHOW_POWER_USER_TOOLS,
    };
}
